import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2024</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Data Analysis"
            subTitle="PORN-TECH TOOLS COMPANY LIMITED - (March - July 2024)"
            result="Chiang Mai, Thailand"
            des="Developed dashboards using Power BI and MERN stack, including a Financial Tracker, a Product Monitor reducing inventory costs by 30%, and a Debt System analyzing NPL behavior and predicting payment trends for better decisions."
          />
          <ResumeCard
            title="Portfolio Guidance Trainer"
            subTitle="The Prince Royal’s College"
            result="Chiang Mai, Thailand"
            des="Provides advice and support to individuals in developing and refining their professional portfolios, helping them showcase their skills, experiences, and achievements effectively, help over 100 student for university preparation."
          />
          <ResumeCard
            title="ESport Organizer Team"
            subTitle="The Prince Royal’s College"
            result="Chiang Mai, Thailand"
            des="Plans, manages, and executes esports events, coordinating logistics, team participation, and ensuring smooth competition operations."
          />
        </div>
      </div>
      <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2024</p>
          <h2 className="text-4xl font-bold">Volunteer Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Asia World Model United Nations (AWMUN)"
            subTitle="International Global Network (IGN)"
            result="Bangkok, Thailand"
            des="A Model United Nations (MUN) conference that provides a platform for young leaders to develop their skills and gain experience in diplomacy, leadership, and negotiation."
          />
          <ResumeCard
            title="2024 Academic Student Council"
            subTitle="The Prince Royal’s College"
            result="Chiang Mai, Thailand"
            des="Represents students’ academic interests, promoting initiatives and ensuring their voices are heard in decision-making."
          />
          <ResumeCard
            title="Thailand First Tech Challenge Volunteer"
            subTitle="The Prince Royal’s College"
            result="Chiang Mai, Thailand"
            des="Supports and assists in organizing and running the FIRST Tech Challenge robotics competition in Thailand, helping teams and promoting STEM education."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;